function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "cn_svg__a",
  fill: "#ffde00",
  d: "M1-.3L-.7.8 0-1 .6.8-1-.3z"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#de2910",
  d: "M0 0h512v512H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("use", {
  width: 30,
  height: 20,
  transform: "matrix(76.8 0 0 76.8 128 128)",
  xlinkHref: "#cn_svg__a"
});

var _ref4 = /*#__PURE__*/React.createElement("use", {
  width: 30,
  height: 20,
  transform: "rotate(-121 142.6 -47) scale(25.5827)",
  xlinkHref: "#cn_svg__a"
});

var _ref5 = /*#__PURE__*/React.createElement("use", {
  width: 30,
  height: 20,
  transform: "rotate(-98.1 198 -82) scale(25.6)",
  xlinkHref: "#cn_svg__a"
});

var _ref6 = /*#__PURE__*/React.createElement("use", {
  width: 30,
  height: 20,
  transform: "rotate(-74 272.4 -114) scale(25.6137)",
  xlinkHref: "#cn_svg__a"
});

var _ref7 = /*#__PURE__*/React.createElement("use", {
  width: 30,
  height: 20,
  transform: "matrix(16 -19.968 19.968 16 256 230.4)",
  xlinkHref: "#cn_svg__a"
});

function SvgCn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default "assets/cn.f5a6f04.svg";
export { SvgCn as ReactComponent };